import { useState } from 'react';
import { useAuth } from '@/lib/AuthContext';
import BugReportButton from './BugReportButton';
import BugReportDialog from './BugReportDialog';

// Auth-gated container for the bug-report widget. Shows the inline trigger
// only to authenticated users and owns the dialog open state. Mounted inline
// in the TopBar.
export default function BugReportWidget() {
  const { isAuthenticated, user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!isAuthenticated) return null;

  return (
    <>
      <BugReportButton onClick={() => setOpen(true)} />
      <BugReportDialog open={open} onOpenChange={setOpen} user={user} />
    </>
  );
}
